import useInviteUserToTeam from '@/hooks/useInviteUserToTeam'
import { Stack, Text } from './custom-components'
import { Button } from './shadcn/button'
import { Input } from './shadcn/input'
import { Select, SelectContent, SelectGroup, SelectItem, SelectTrigger, SelectValue } from './shadcn/select'

const UserProfileDialogTeamsInviteUserSection = () => {
  const { emailToInvite, setEmailToInvite, role, setRole, isEmailValid, inviteUsers, isPending } = useInviteUserToTeam()

  return (
    <Stack className="p-4 gap-4 rounded-2xl border border-themesidebarborder dark:border-themesidebarborderdark overflow-hidden">
      <Text size="sm" weight="medium">
        Invite by email
      </Text>

      <div className="flex flex-col gap-2">
        <div className="flex gap-3 items-center">
          <Input
            value={emailToInvite}
            type="email"
            placeholder="name@example.com"
            onChange={(e) => setEmailToInvite(e.target.value)}
            disabled={isPending}
          />

          <Select disabled={isPending} value={role} onValueChange={(val) => setRole(val as 'creator' | 'commenter')}>
            <SelectTrigger className="w-fit">
              <SelectValue placeholder="Select role" />
            </SelectTrigger>
            <SelectContent>
              <SelectGroup>
                <SelectItem value="creator">Creator</SelectItem>
                <SelectItem value="commenter">Commenter</SelectItem>
              </SelectGroup>
            </SelectContent>
          </Select>

          <Button
            variant="destructivePurple"
            disabled={!isEmailValid || isPending}
            loading={isPending}
            onClick={() => {
              inviteUsers([{ email: emailToInvite, role }])
            }}
          >
            Send Invite
          </Button>
        </div>

        {emailToInvite.length > 0 && !isEmailValid && (
          <Text size="xs" className="text-red-500">
            This is not a valid email
          </Text>
        )}
      </div>
    </Stack>
  )
}

export default UserProfileDialogTeamsInviteUserSection
